import React from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { StickyNote } from "lucide-react";

const formatNoteDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export const MemberNoteDialog = ({
  open,
  onOpenChange,
  noteMember,
  noteText,
  setNoteText,
  memberNotes,
  onSubmit,
  saving,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#1a1a1b] border-red-900/30 max-w-lg">
        <DialogHeader>
          <DialogTitle className="text-red-50 flex items-center gap-2">
            <StickyNote size={18} className="text-purple-400" />
            Catatan Member: {noteMember?.username}
          </DialogTitle>
          <DialogDescription className="text-gray-400">
            {noteMember?.marketing_name} • {noteMember?.website} • Kode: {noteMember?.kode_db}
          </DialogDescription>
        </DialogHeader>

        {memberNotes.length > 0 && (
          <div className="space-y-2 max-h-48 overflow-y-auto pr-1">
            <Label className="text-gray-300 text-xs uppercase tracking-wider">Catatan Sebelumnya</Label>
            {memberNotes.map((n) => (
              <div key={n.id} className="text-sm bg-[#0f0f10] border border-purple-900/30 rounded px-3 py-2">
                <div className="text-gray-200 italic">"{n.note}"</div>
                <div className="text-xs text-gray-500 mt-1">
                  {n.actor_name} • {formatNoteDate(n.created_at)}
                </div>
              </div>
            ))}
          </div>
        )}

        <form onSubmit={onSubmit} className="space-y-3">
          <div>
            <Label htmlFor="new-note" className="text-gray-300">Catatan Baru</Label>
            <Textarea
              id="new-note"
              value={noteText}
              onChange={(e) => setNoteText(e.target.value)}
              placeholder="Tulis catatan untuk member ini..."
              rows={4}
              className="bg-[#0f0f10] border-red-900/30 text-white mt-2"
              required
              data-testid="member-note-textarea"
            />
          </div>
          <DialogFooter className="gap-2 sm:gap-0">
            <Button
              type="button"
              onClick={() => onOpenChange(false)}
              variant="outline"
              className="border-red-900/30 text-white hover:bg-red-900/20"
            >
              Tutup
            </Button>
            <Button
              type="submit"
              disabled={saving}
              className="bg-purple-700 hover:bg-purple-800 text-white"
              data-testid="member-save-note-btn"
            >
              {saving ? "Menyimpan..." : "Simpan Catatan"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default MemberNoteDialog;
